module.exports = __webpack_public_path__ + "img/9.f96dea67.png";